import { render } from "./MukHuntPage.vue?vue&type=template&id=055a1836&scoped=true"
import script from "./MukHuntPage.vue?vue&type=script&lang=js"
export * from "./MukHuntPage.vue?vue&type=script&lang=js"

import "./MukHuntPage.vue?vue&type=style&index=0&id=055a1836&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055a1836"]])

export default __exports__